<!-- =========================================================================================
  File Name: InstituteView.vue
  Description: Institute View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-institute-view">

    <div id="institute-data" v-if="institute_data">

      <vx-card title="학원 상세 정보" class="mb-base">

        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="institute-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">학원명</td>
                <td>{{ institute_data.instituteName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">캠퍼스 명칭</td>
                <td>{{ institute_data.campusName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">사업자명</td>
                <td>{{ institute_data.contractorName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">사업자와의 관계</td>
                <td>{{ institute_data.contractorRelation }}</td>
              </tr>
              <tr>
                <td class="font-semibold">학원장명</td>
                <td>{{ institute_data.presidentName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">계약자와의 관계</td>
                <td>{{ institute_data.presidentRelation }}</td>
              </tr>
              <tr>
                <td class="font-semibold">사업자번호</td>
                <td>{{ institute_data.businessNumber }}</td>
              </tr>
              <tr>
                <td class="font-semibold">전화 번호</td>
                <td>{{ institute_data.telephone  }}</td>
              </tr>
              <tr>
                <td class="font-semibold">이동전화번호</td>
                <td>{{ institute_data.mobilephone  }}</td>
              </tr>
              <tr>
                <td class="font-semibold">팩스번호</td>
                <td>{{ institute_data.fax  }}</td>
              </tr>
              <tr>
                <td class="font-semibold">대표 이메일</td>
                <td>{{ institute_data.eMail }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">학원장ID</td>
                <td>{{ institute_data.instituteChiefID }}</td>
              </tr>
              <tr>
                <td class="font-semibold">우편번호</td>
                <td>{{ institute_data.zipCode }}</td>
              </tr>
              <tr>
                <td class="font-semibold">주소</td>
                <td>{{ institute_data.zipName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">주소세부</td>
                <td>{{ institute_data.zipDetail }}</td>
              </tr>
              <tr>
                <td class="font-semibold">가맹 계약일</td>
                <td>{{ institute_data.frContractDate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">정보입력일</td>
                <td>{{ institute_data.createDate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">가맹 만료일</td>
                <td>{{ institute_data.frEndDate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">최대 수강생수</td>
                <td>{{ institute_data.licenseCnt }}명</td>
              </tr>
              <tr>
                <td class="font-semibold">현재 수강생수</td>
                <td>{{ institute_data.studentCnt }}명</td>
              </tr>
              <!-- <tr>
                <td class="font-semibold">검색주소</td>
                <td>{{ institute_data.addressSearch }}</td>
              </tr> -->
              <!-- <tr>
                <td class="font-semibold">홈페이지노출</td>
                <td>차단여부 : {{ institute_data.displayChk == 'Y'? '보여짐':'안보여짐'}}</td>
              </tr> -->
              <!-- <tr>
                <td class="font-semibold">도메인</td>
                <td>{{ institute_data.domain }}</td>
              </tr> -->
              <!-- <tr>
                <td class="font-semibold">캠퍼스 특이사항 메모</td>
                <td>{{ institute_data.memo }}</td>
              </tr> -->
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex justify-end" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="onEdit">수정</vs-button>
            <!-- <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">삭제</vs-button> -->
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { fetchData } from '@/api/module'

export default {
  data () {
    return {
      institute_data: null
    }
  },
  computed: {
    instituteSeq () {
      return this.institute_data.instituteSeq
    }
  },
  methods: {
    onEdit () {
      this.$router.push('/institute/institute-edit')
    },
    async loadItem () {
      try {
        const { data } = await fetchData('/my-institute')
        this.institute_data = data.data
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.loadItem()
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-institute-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
